import React, {useEffect, useState}                                                              from 'react'
import {Alert, AlertTitle, Box, Button, CircularProgress, Container, Link, Typography, useTheme} from "@mui/material"
import moment                                                                                    from "moment"
import {doGet}                                                       from "../../util/do-fetch"
import {useNavigate, useParams}                                      from "react-router-dom"
import PackageDetail                                                   from "./PackageDetail"
import {useUserStore}                                                from "../../state"
import LoadingDots                                                   from "../LoadingDots"
import GradientCard                                                  from "../GradientCard"
import useQuery                                                                from "../../hooks/useQuery"
import CouponCodeBanner
                                                                                                 from "./CouponCodeBanner"


const CouponRedirect = () => {
	const {code, pct} = useQuery()
	const {user} = useUserStore()
	const navigate = useNavigate()
	const theme = useTheme()
	const [prepKit, setPrepKit] = useState(null)
	const [prepKits, setPrepKits] = useState(null)
	const [error, setError] = useState(null)

	useEffect(() => {
		const fetchExpiredPrepKits = async () => {
			const response = await doGet(`/mini/prepkits/expired`)
			if (response.ok) {
				const expiredPrepKits = await response.json()
				if(expiredPrepKits && expiredPrepKits.length === 1) {
					setPrepKit(expiredPrepKits[0])
				}
				else {
					setPrepKits(expiredPrepKits)
				}
			}
			else {
				setError("Error locating your expired PrepKit.")
			}
		}
		if (user) {
			fetchExpiredPrepKits()
		}
		else {
			setPrepKit(null)
			setPrepKits(null)
		}
	}, [user])

	useEffect(() => {
		if(prepKit) {
			const qs = code && pct ? `?code=${code}&pct=${pct}` : ''
			const url = `/prepkit/${prepKit.id}${qs}`
			navigate(url)
		}
	}, [prepKit])

	let comp = null

	if(prepKits) {
		comp = (
			<Box display={"flex"}
			     flexDirection={"column"}
			     justifyContent={"center"}
			     alignItems={"center"}
			>
				<Typography variant={"h5"} sx={{pb: 2}}>
					Extend your PrepKit today and save!
				</Typography>
				<CouponCodeBanner code={code} pct={pct} />
				<ul style={{
						border: `1px solid ${theme.palette.divider}`,
						backgroundColor: theme.palette.background.default,
						padding: '15px',
						marginTop: '15px'
					}}
				>
				{
					prepKits && prepKits.map(pk => {
						return <li key={pk.id} style={{padding: "5px"}}>
							<Link
								sx={{cursor: "pointer"}}
								onClick={() => setPrepKit(pk)}
							>
								{pk.name}
							</Link>
						</li>
					})
				}
				</ul>
			</Box>
		)
	}
	else {
		comp = (
			<Box pt={10}>
				<LoadingDots/>
			</Box>
		)
	}

	return (
		<Container maxWidth="sm">
			{
				error &&
				<Alert severity="warning">
					<AlertTitle>Error locating expired PrepKit.</AlertTitle>
					{error}
					<ul>
						<li>Go to your <a href={"/prepkit"}>PrepKit page</a> and click Extend.</li>
						<li>Use coupon code <strong>${code}</strong> when you checkout.</li>
					</ul>
				</Alert>
			}
			{comp}
		</Container>
	)
}

export default CouponRedirect
